<template>
	<div class="newDetailBox" v-cloak>
		<!-- 背景是图片 -->
		<div class="newDetail">
        <p class="newDetailTitle">{{newDetailDatas.title}}</p>
        <p class="BrowsingNum detailConTitleTips">浏览量<span>{{newDetailDatas.page_view}}</span></p>
        <p class="from detailConTitleTips">来源<span>{{newDetailDatas.source}}</span></p>
        <p class="time detailConTitleTips"><span>{{newDetailDatas.publish_time_format}}</span></p>
        <div class="newDetailConBox" v-html="newDetailDatas.content"></div>
        <p class="readRecTitle">阅读推荐</p>
        <p class="recConLi" v-for="(items,index) in newDetailRecDatas">
          <router-link :to="{name:'NewDetail',query:{detailID:items.id}}">
            <span class="readRecNum">0{{parseInt(index+1)}}</span>
            <span class="readRecCon">{{items.title}}</span>
          </router-link>  
        </p>
    </div>
    <div class="homeBotTxt">
      <p>Copyright ©2018 思考乐教育</p>
      <div>
        <router-link to="/LegalDeclaration">法律声明</router-link>
        <span class="l">|</span>
        <router-link :to="{name:'CampusCon',query:{id:1,cityId:1001}}">校区导航</router-link>
      </div>
    </div>
    </div>
	</div>
</template>

<script>
import '../../../static/js/swiper.min.js'
export default {
  name: 'Home',
  data () {
    return {
      newDetailDatas: '',
      newDetailRecDatas: ''
    }
  },
  created(){
    this.axios.get(this.$root.baseUrl+'/wap/news/'+this.$route.query.detailID)
    .then(res=>{
      this.newDetailDatas = res.data.newsMap;
      this.newDetailRecDatas = res.data.recNewsList;
      console.log(this.newDetailDatas)
      console.log(this.newDetailDatas.publish_time_format)
    })
    .catch(e=>{
      console.log(e)
    })
  },
  watch: {
    $route: {
      handler: function(newVal, oldVal){
         this.axios.get(this.$root.baseUrl+'/wap/news/'+this.$route.query.detailID)
          .then(res=>{
            this.newDetailDatas = res.data.newsMap;
            this.newDetailRecDatas = res.data.recNewsList;
            window.scrollTo(0,0);
            console.log(res.data)
          })
          .catch(e=>{
            console.log(e)
          })
        },
      deep: true
    }
  },
}

</script>
<style>
	
.newDetailBox{
	width: 100%;
  height: 100%;
  margin-top: 3.2rem;
}	
.newDetail{
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
}
.detailConTitleTips{
    font-size: 0.86667rem;
    color: #ccc;
    display: inline-block;
    /*margin-right: 1.6rem;*/
    margin:0 1rem 2rem 0;
}
.detailConTitleTips span{
  /*margin-left: 0.6667rem;*/
  margin-left: 0.4rem;
}
.newDetailTitle{
    font-size: 1.46667rem;
    color: #333;
    font-weight: bold;
    margin: 1rem auto;
    display: inline-block;
}
.newDetailConBox{
    margin-bottom: 6.6rem;
}
.newDetailConBox img{
    width: 100%;
    height: auto!important;
}
.newDetailConBox p{
    margin: 2.9333rem 0;
    font-size: 1.06667rem!important;
    line-height: 2rem;
}
.newDetailConBox p img{
  margin-bottom: -0.93333rem;
}
.newDetailBox .recConLi{
  margin-bottom: 2.26667rem;
}
.readRecTitle{
  font-size: 1.46667rem;
  font-weight: bolder;
  box-sizing: border-box;
  /*padding-left: 1rem;*/
  margin: 3.4rem 0 2.6667rem;
  display: inline-block;
}
.readRec{
  border-top: 3px solid #f7f8f9;
  margin: 2rem 0;
  display: inline-block;
}
.readRec p{
  margin-bottom: 2.3rem;
}
.readRec p:nth-child(5){
  margin: 0;
}
.readRecNum{
  font-size: 2rem;
  color: #e6e6e6;
  display: inline-block;
  vertical-align: middle; 
  font-weight: bolder;
}
.readRecCon{
  display: inline-block;
  font-size: 1.06667rem;
  width: 18.6667rem;
  margin-left: 1.4rem;
  vertical-align: middle;
}
.footTxt{
  width: 100%;
  height: 3rem;
  background: #f7f8f9;
  line-height: 3rem;
  text-align: center;
  color: #ccc;
}
a{
  color: #333;
}
[v-cloak]{ display :none }
.homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
}
.homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
}
</style>


// WEBPACK FOOTER //
// src/components/newDetail/NewDetail.vue